// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/auction/v1/auction.proto (package penumbra.core.component.auction.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Any, Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Position, PositionId } from "../../dex/v1/dex_pb.js";
import { AssetId, BalanceCommitment, Metadata, Value, ValueView } from "../../../asset/v1/asset_pb.js";
import { Amount } from "../../../num/v1/num_pb.js";
/**
 * The configuration parameters for the auction component.
 *
 * @generated from message penumbra.core.component.auction.v1.AuctionParameters
 */
export class AuctionParameters extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.AuctionParameters";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new AuctionParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionParameters, a, b);
    }
}
/**
 * Genesis data for the auction component.
 *
 * @generated from message penumbra.core.component.auction.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * The configuration parameters for the auction component at genesis.
     *
     * @generated from field: penumbra.core.component.auction.v1.AuctionParameters params = 1;
     */
    params;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "params", kind: "message", T: AuctionParameters },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.AuctionStateByIdRequest
 */
export class AuctionStateByIdRequest extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId id = 1;
     */
    id;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.AuctionStateByIdRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "message", T: AuctionId },
    ]);
    static fromBinary(bytes, options) {
        return new AuctionStateByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionStateByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionStateByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionStateByIdRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.AuctionStateByIdResponse
 */
export class AuctionStateByIdResponse extends Message {
    /**
     * If present, the state of the auction. If not present, no such auction is known.
     *
     * @generated from field: google.protobuf.Any auction = 2;
     */
    auction;
    /**
     * The state of any DEX positions relevant to the returned auction.
     *
     * Could be empty, depending on the auction state.
     *
     * @generated from field: repeated penumbra.core.component.dex.v1.Position positions = 3;
     */
    positions = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.AuctionStateByIdResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "auction", kind: "message", T: Any },
        { no: 3, name: "positions", kind: "message", T: Position, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AuctionStateByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionStateByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionStateByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionStateByIdResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.AuctionStateByIdsRequest
 */
export class AuctionStateByIdsRequest extends Message {
    /**
     * The auction IDs to request. Only known IDs will be returned in the response.
     *
     * @generated from field: repeated penumbra.core.component.auction.v1.AuctionId id = 1;
     */
    id = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.AuctionStateByIdsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "message", T: AuctionId, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AuctionStateByIdsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionStateByIdsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionStateByIdsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionStateByIdsRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.AuctionStateByIdsResponse
 */
export class AuctionStateByIdsResponse extends Message {
    /**
     * The auction ID of the returned auction.
     *
     * @generated from field: penumbra.core.component.auction.v1.AuctionId id = 1;
     */
    id;
    /**
     * The state of the returned auction.
     *
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionState auction = 2;
     */
    auction;
    /**
     * The state of any DEX positions relevant to the returned auction.
     *
     * Could be empty, depending on the auction state.
     *
     * @generated from field: repeated penumbra.core.component.dex.v1.Position positions = 3;
     */
    positions = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.AuctionStateByIdsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "message", T: AuctionId },
        { no: 2, name: "auction", kind: "message", T: DutchAuctionState },
        { no: 3, name: "positions", kind: "message", T: Position, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AuctionStateByIdsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionStateByIdsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionStateByIdsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionStateByIdsResponse, a, b);
    }
}
/**
 * A unique identifier for an auction, obtained from hashing a domain separator
 * along with the immutable part of an auction description.
 *
 * @generated from message penumbra.core.component.auction.v1.AuctionId
 */
export class AuctionId extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.AuctionId";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new AuctionId().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionId().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionId().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionId, a, b);
    }
}
/**
 * A bearer NFT tracking ownership of an auction and its proceeds.
 *
 * @generated from message penumbra.core.component.auction.v1.AuctionNft
 */
export class AuctionNft extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId id = 1;
     */
    id;
    /**
     * @generated from field: uint64 seq = 2;
     */
    seq = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.AuctionNft";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "message", T: AuctionId },
        { no: 2, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new AuctionNft().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionNft().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionNft().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionNft, a, b);
    }
}
/**
 * Describes a Dutch auction using programmatic liquidity on the DEX.
 *
 * @generated from message penumbra.core.component.auction.v1.DutchAuctionDescription
 */
export class DutchAuctionDescription extends Message {
    /**
     * The value the seller wishes to auction.
     *
     * @generated from field: penumbra.core.asset.v1.Value input = 1;
     */
    input;
    /**
     * The asset ID of the target asset the seller wishes to acquire.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId output_id = 2;
     */
    outputId;
    /**
     * The maximum output the seller can receive.
     *
     * This implicitly defines the starting price for the auction.
     *
     * @generated from field: penumbra.core.num.v1.Amount max_output = 3;
     */
    maxOutput;
    /**
     * The minimum output the seller is willing to receive.
     *
     * This implicitly defines the ending price for the auction.
     *
     * @generated from field: penumbra.core.num.v1.Amount min_output = 4;
     */
    minOutput;
    /**
     * The block height at which the auction begins.
     *
     * This allows the seller to schedule an auction at a future time.
     *
     * @generated from field: uint64 start_height = 5;
     */
    startHeight = protoInt64.zero;
    /**
     * The block height at which the auction ends.
     *
     * Together with `start_height`, `max_output`, and `min_output`,
     * this implicitly defines the speed of the auction.
     *
     * @generated from field: uint64 end_height = 6;
     */
    endHeight = protoInt64.zero;
    /**
     * The number of discrete price steps to use for the auction.
     *
     * `end_height - start_height` must be a multiple of `step_count`.
     *
     * @generated from field: uint64 step_count = 7;
     */
    stepCount = protoInt64.zero;
    /**
     * A random nonce used to allow identical auctions to have
     * distinct auction IDs.
     *
     * @generated from field: bytes nonce = 8;
     */
    nonce = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.DutchAuctionDescription";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "input", kind: "message", T: Value },
        { no: 2, name: "output_id", kind: "message", T: AssetId },
        { no: 3, name: "max_output", kind: "message", T: Amount },
        { no: 4, name: "min_output", kind: "message", T: Amount },
        { no: 5, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 6, name: "end_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 7, name: "step_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 8, name: "nonce", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new DutchAuctionDescription().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutchAuctionDescription().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutchAuctionDescription().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutchAuctionDescription, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.DutchAuctionState
 */
export class DutchAuctionState extends Message {
    /**
     * The sequence number of the auction state.
     *
     * Dutch auctions move from:
     * 0 (opened) => 1 (closed) => n (withdrawn)
     *
     * @generated from field: uint64 seq = 1;
     */
    seq = protoInt64.zero;
    /**
     * If present, the current position controlled by this auction.
     *
     * @generated from field: penumbra.core.component.dex.v1.PositionId current_position = 2;
     */
    currentPosition;
    /**
     * If present, the next trigger height to step down the price.
     *
     * @generated from field: uint64 next_trigger = 3;
     */
    nextTrigger = protoInt64.zero;
    /**
     * The amount of the input asset directly owned by the auction.
     *
     * The auction may also own the input asset indirectly,
     * via the reserves of `current_position` if it exists.
     *
     * @generated from field: penumbra.core.num.v1.Amount input_reserves = 4;
     */
    inputReserves;
    /**
     * The amount of the output asset directly owned by the auction.
     *
     * The auction may also own the output asset indirectly,
     * via the reserves of `current_position` if it exists.
     *
     * @generated from field: penumbra.core.num.v1.Amount output_reserves = 5;
     */
    outputReserves;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.DutchAuctionState";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "current_position", kind: "message", T: PositionId },
        { no: 3, name: "next_trigger", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "input_reserves", kind: "message", T: Amount },
        { no: 5, name: "output_reserves", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new DutchAuctionState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutchAuctionState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutchAuctionState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutchAuctionState, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.DutchAuction
 */
export class DutchAuction extends Message {
    /**
     * The immutable data describing the auction and its auction ID.
     *
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionDescription description = 1;
     */
    description;
    /**
     * The mutable data describing the auction's execution.
     *
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionState state = 2;
     */
    state;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.DutchAuction";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "description", kind: "message", T: DutchAuctionDescription },
        { no: 2, name: "state", kind: "message", T: DutchAuctionState },
    ]);
    static fromBinary(bytes, options) {
        return new DutchAuction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutchAuction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutchAuction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutchAuction, a, b);
    }
}
/**
 * Initiates a Dutch auction using protocol-controlled liquidity.
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionSchedule
 */
export class ActionDutchAuctionSchedule extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionDescription description = 1;
     */
    description;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.ActionDutchAuctionSchedule";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "description", kind: "message", T: DutchAuctionDescription },
    ]);
    static fromBinary(bytes, options) {
        return new ActionDutchAuctionSchedule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionDutchAuctionSchedule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionDutchAuctionSchedule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionDutchAuctionSchedule, a, b);
    }
}
/**
 * Terminate the auction associated with the specified `auction_id`
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionEnd
 */
export class ActionDutchAuctionEnd extends Message {
    /**
     * The auction to end.
     *
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.ActionDutchAuctionEnd";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    ]);
    static fromBinary(bytes, options) {
        return new ActionDutchAuctionEnd().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionDutchAuctionEnd().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionDutchAuctionEnd().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionDutchAuctionEnd, a, b);
    }
}
/**
 * Withdraw funds from the ended auction associated with the specified `auction_id`
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionWithdraw
 */
export class ActionDutchAuctionWithdraw extends Message {
    /**
     * The auction to withdraw funds from.
     *
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    /**
     * The sequence number of the withdrawal.
     *
     * @generated from field: uint64 seq = 2;
     */
    seq = protoInt64.zero;
    /**
     * A transparent (zero blinding factor) commitment to the
     * auction's final reserves.
     *
     * The chain will check this commitment by recomputing it
     * with the on-chain state.
     *
     * @generated from field: penumbra.core.asset.v1.BalanceCommitment reserves_commitment = 3;
     */
    reservesCommitment;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.ActionDutchAuctionWithdraw";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
        { no: 2, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "reserves_commitment", kind: "message", T: BalanceCommitment },
    ]);
    static fromBinary(bytes, options) {
        return new ActionDutchAuctionWithdraw().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionDutchAuctionWithdraw().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionDutchAuctionWithdraw().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionDutchAuctionWithdraw, a, b);
    }
}
/**
 * A plan to a `ActionDutchAuctionWithdraw` which contains both private and public data.
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionWithdrawPlan
 */
export class ActionDutchAuctionWithdrawPlan extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    /**
     * @generated from field: uint64 seq = 2;
     */
    seq = protoInt64.zero;
    /**
     * @generated from field: penumbra.core.asset.v1.Value reserves_input = 3;
     */
    reservesInput;
    /**
     * @generated from field: penumbra.core.asset.v1.Value reserves_output = 4;
     */
    reservesOutput;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.ActionDutchAuctionWithdrawPlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
        { no: 2, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "reserves_input", kind: "message", T: Value },
        { no: 4, name: "reserves_output", kind: "message", T: Value },
    ]);
    static fromBinary(bytes, options) {
        return new ActionDutchAuctionWithdrawPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionDutchAuctionWithdrawPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionDutchAuctionWithdrawPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionDutchAuctionWithdrawPlan, a, b);
    }
}
/**
 * An `ActionDutchAuctionSchedule` augmented with additional metadata.
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionScheduleView
 */
export class ActionDutchAuctionScheduleView extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.ActionDutchAuctionSchedule action = 1;
     */
    action;
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 2;
     */
    auctionId;
    /**
     * @generated from field: penumbra.core.asset.v1.Metadata input_metadata = 3;
     */
    inputMetadata;
    /**
     * @generated from field: penumbra.core.asset.v1.Metadata output_metadata = 4;
     */
    outputMetadata;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.ActionDutchAuctionScheduleView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "action", kind: "message", T: ActionDutchAuctionSchedule },
        { no: 2, name: "auction_id", kind: "message", T: AuctionId },
        { no: 3, name: "input_metadata", kind: "message", T: Metadata },
        { no: 4, name: "output_metadata", kind: "message", T: Metadata },
    ]);
    static fromBinary(bytes, options) {
        return new ActionDutchAuctionScheduleView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionDutchAuctionScheduleView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionDutchAuctionScheduleView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionDutchAuctionScheduleView, a, b);
    }
}
/**
 * An `ActionDutchAuctionWithdraw` augmented with additional metadata.
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionWithdrawView
 */
export class ActionDutchAuctionWithdrawView extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.ActionDutchAuctionWithdraw action = 1;
     */
    action;
    /**
     * A sequence of values that sum together to the provided
     * reserves commitment.
     *
     * @generated from field: repeated penumbra.core.asset.v1.ValueView reserves = 2;
     */
    reserves = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.ActionDutchAuctionWithdrawView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "action", kind: "message", T: ActionDutchAuctionWithdraw },
        { no: 2, name: "reserves", kind: "message", T: ValueView, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ActionDutchAuctionWithdrawView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionDutchAuctionWithdrawView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionDutchAuctionWithdrawView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionDutchAuctionWithdrawView, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.EventDutchAuctionScheduled
 */
export class EventDutchAuctionScheduled extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    /**
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionDescription description = 2;
     */
    description;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.EventDutchAuctionScheduled";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
        { no: 2, name: "description", kind: "message", T: DutchAuctionDescription },
    ]);
    static fromBinary(bytes, options) {
        return new EventDutchAuctionScheduled().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventDutchAuctionScheduled().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventDutchAuctionScheduled().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventDutchAuctionScheduled, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.EventDutchAuctionUpdated
 */
export class EventDutchAuctionUpdated extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    /**
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionState state = 2;
     */
    state;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.EventDutchAuctionUpdated";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
        { no: 2, name: "state", kind: "message", T: DutchAuctionState },
    ]);
    static fromBinary(bytes, options) {
        return new EventDutchAuctionUpdated().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventDutchAuctionUpdated().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventDutchAuctionUpdated().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventDutchAuctionUpdated, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.auction.v1.EventDutchAuctionEnded
 */
export class EventDutchAuctionEnded extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    /**
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionState state = 2;
     */
    state;
    /**
     * @generated from field: penumbra.core.component.auction.v1.EventDutchAuctionEnded.Reason reason = 3;
     */
    reason = EventDutchAuctionEnded_Reason.UNSPECIFIED;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.EventDutchAuctionEnded";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
        { no: 2, name: "state", kind: "message", T: DutchAuctionState },
        { no: 3, name: "reason", kind: "enum", T: proto3.getEnumType(EventDutchAuctionEnded_Reason) },
    ]);
    static fromBinary(bytes, options) {
        return new EventDutchAuctionEnded().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventDutchAuctionEnded().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventDutchAuctionEnded().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventDutchAuctionEnded, a, b);
    }
}
/**
 * The reason the auction ended.
 *
 * @generated from enum penumbra.core.component.auction.v1.EventDutchAuctionEnded.Reason
 */
export var EventDutchAuctionEnded_Reason;
(function (EventDutchAuctionEnded_Reason) {
    /**
     * @generated from enum value: REASON_UNSPECIFIED = 0;
     */
    EventDutchAuctionEnded_Reason[EventDutchAuctionEnded_Reason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * The auction ended due to reaching its terminal height.
     *
     * @generated from enum value: REASON_EXPIRED = 1;
     */
    EventDutchAuctionEnded_Reason[EventDutchAuctionEnded_Reason["EXPIRED"] = 1] = "EXPIRED";
    /**
     * The auction ran out of reserves.
     *
     * @generated from enum value: REASON_FILLED = 2;
     */
    EventDutchAuctionEnded_Reason[EventDutchAuctionEnded_Reason["FILLED"] = 2] = "FILLED";
    /**
     * The auction ended was terminated by the initiator.
     *
     * @generated from enum value: REASON_CLOSED_BY_OWNER = 3;
     */
    EventDutchAuctionEnded_Reason[EventDutchAuctionEnded_Reason["CLOSED_BY_OWNER"] = 3] = "CLOSED_BY_OWNER";
})(EventDutchAuctionEnded_Reason || (EventDutchAuctionEnded_Reason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EventDutchAuctionEnded_Reason)
proto3.util.setEnumType(EventDutchAuctionEnded_Reason, "penumbra.core.component.auction.v1.EventDutchAuctionEnded.Reason", [
    { no: 0, name: "REASON_UNSPECIFIED" },
    { no: 1, name: "REASON_EXPIRED" },
    { no: 2, name: "REASON_FILLED" },
    { no: 3, name: "REASON_CLOSED_BY_OWNER" },
]);
/**
 * @generated from message penumbra.core.component.auction.v1.EventDutchAuctionWithdrawn
 */
export class EventDutchAuctionWithdrawn extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    /**
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionState state = 2;
     */
    state;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.EventDutchAuctionWithdrawn";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
        { no: 2, name: "state", kind: "message", T: DutchAuctionState },
    ]);
    static fromBinary(bytes, options) {
        return new EventDutchAuctionWithdrawn().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventDutchAuctionWithdrawn().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventDutchAuctionWithdrawn().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventDutchAuctionWithdrawn, a, b);
    }
}
/**
 * A message emitted when value flows *into* the auction component.
 *
 * @generated from message penumbra.core.component.auction.v1.EventValueCircuitBreakerCredit
 */
export class EventValueCircuitBreakerCredit extends Message {
    /**
     * The asset ID being deposited into the Auction component.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id = 1;
     */
    assetId;
    /**
     * The previous balance of the asset in the Auction component.
     *
     * @generated from field: penumbra.core.num.v1.Amount previous_balance = 2;
     */
    previousBalance;
    /**
     * The new balance of the asset in the Auction component.
     *
     * @generated from field: penumbra.core.num.v1.Amount new_balance = 3;
     */
    newBalance;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.EventValueCircuitBreakerCredit";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "asset_id", kind: "message", T: AssetId },
        { no: 2, name: "previous_balance", kind: "message", T: Amount },
        { no: 3, name: "new_balance", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new EventValueCircuitBreakerCredit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventValueCircuitBreakerCredit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventValueCircuitBreakerCredit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventValueCircuitBreakerCredit, a, b);
    }
}
/**
 * A message emitted when value flows *out* of the auction component.
 *
 * @generated from message penumbra.core.component.auction.v1.EventValueCircuitBreakerDebit
 */
export class EventValueCircuitBreakerDebit extends Message {
    /**
     * The asset ID being deposited into the Auction component.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id = 1;
     */
    assetId;
    /**
     * The previous balance of the asset in the Auction component.
     *
     * @generated from field: penumbra.core.num.v1.Amount previous_balance = 2;
     */
    previousBalance;
    /**
     * The new balance of the asset in the Auction component.
     *
     * @generated from field: penumbra.core.num.v1.Amount new_balance = 3;
     */
    newBalance;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.auction.v1.EventValueCircuitBreakerDebit";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "asset_id", kind: "message", T: AssetId },
        { no: 2, name: "previous_balance", kind: "message", T: Amount },
        { no: 3, name: "new_balance", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new EventValueCircuitBreakerDebit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventValueCircuitBreakerDebit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventValueCircuitBreakerDebit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventValueCircuitBreakerDebit, a, b);
    }
}
